export const FileUploadMegabyteLimit = 20;
export const FileUploadLimit = FileUploadMegabyteLimit * (1024 * 1024); // 20 mb
export const UserEligibleMinimumAge = 18;
